import _ from 'lodash'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime } from 'common/usual'
import {
  Card,
  CardContent,
  CardActions,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Grid,
  TextField,
} from '@material-ui/core'
import AddBtn from 'components/AddBtn'
import EditBtn from 'components/EditBtn'
import { brazeCampaignListPromise } from 'api/BrazeCampaign'
import { useLocation } from 'react-router-dom'

export default function BrazeCampaignList (props) {
  const ref = useRef()
  const location = useLocation()
  const [data, setData] = useState({})
  const [params, setParams] = useState({})

  // The URL is the source of truth: re-syncing `params` on every change (not once at mount) is what
  // makes browser back/forward move the pagination and the search box, not just the rows.
  useEffect(() => {
    let cancelled = false
    const query = Object.fromEntries(new URLSearchParams(location.search).entries())

    setParams({ page: 1, ...query })
    brazeCampaignListPromise(query).then(resp => { if (!cancelled) setData(resp || {}) })

    // Two quick page clicks leave two requests in flight; without this the slower one can land last
    // and repaint the table with the page the admin already left.
    return () => { cancelled = true }
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const query = Object.fromEntries(new URLSearchParams(location.search))
    const next = _.pickBy({ ...query, page: 1, ...payload }, _.identity)
    setParams(next)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(next)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  return (
    <div className={'root'}>
      <div className={'content'}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={4}>
            <TextField
              fullWidth
              variant='outlined'
              size='small'
              placeholder='Name, campaign key or braze campaign id'
              value={params.keyword || ''}
              className='background-color'
              onChange={event => handleParamsChange({ keyword: event.target.value }, 500)}
            />
          </Grid>
          <Grid item xs={8} className='flex-right'>
            <AddBtn color='primary' variant='contained' onClick={() => props.history.push('/braze-campaigns/add')}>
              Add
            </AddBtn>
          </Grid>
        </Grid>

        <br />

        <Card>
          <CardContent className={'table-content'}>
            <PerfectScrollbar>
              <div className={'inner'}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Campaign Key</TableCell>
                      <TableCell>Braze Campaign ID</TableCell>
                      <TableCell>Message Type</TableCell>
                      <TableCell>OS Type</TableCell>
                      <TableCell>Active</TableCell>
                      <TableCell>Updated At</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data.rows && data.rows.map(campaign => (
                      <TableRow key={campaign.id} hover>
                        <TableCell>{campaign.id}</TableCell>
                        <TableCell>{campaign.name}</TableCell>
                        <TableCell>{campaign.campaignKey}</TableCell>
                        <TableCell>{campaign.brazeCampaignId}</TableCell>
                        <TableCell>{campaign.messageType}</TableCell>
                        <TableCell>{campaign.osType}</TableCell>
                        <TableCell>{campaign.active ? 'TRUE' : 'FALSE'}</TableCell>
                        <TableCell>{formatDateTime(campaign.updatedAt)}</TableCell>
                        <TableCell>
                          <EditBtn history={props.history} path={`/braze-campaigns/edit/${campaign.id}`} />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </PerfectScrollbar>
          </CardContent>

          <CardActions className='flex-right'>
            <TablePagination
              component='div'
              rowsPerPage={10}
              page={(params.page || 1) - 1}
              count={data.count || 0}
              rowsPerPageOptions={[10]}
              onPageChange={handlePageChange}
            />
          </CardActions>
        </Card>
      </div>
    </div>
  )
}
